module.exports = __webpack_public_path__ + "static/img/image052.9e627ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image052.png
// module id = 51bM
// module chunks = 1